export default "__VITE_ASSET__Bos9CFy9__"